export default "__VITE_ASSET__CQ_C0Y4T__"